(function (){
    'use strict';

   
    angular
        .module('app')
        .constant('API_BASE', base_url+'/api/v1')
})();